import "./WetRooms.module.css";
import Header from "@/reusable_sections/Header";
import PrecisionWetRooms from "./sections/PrecisionWetRooms";
import TankingSafety from "./sections/TankingSafety";
import ConsultASpecialist from "./sections/ConsultASpecialist";
import Footer from "@/reusable_sections/Footer";
export default function WetRoomsPage() {
  return <div>
      <Header />
      <PrecisionWetRooms />
      <TankingSafety />
      <ConsultASpecialist />
      <Footer />
    </div>;
}